import { Progress } from '@mantine/core'
import progressClassNames from './styles.module.css'

export default Progress.extend({ classNames: progressClassNames })
